import ActionTypes from "../constants/ActionTypes";

const initialState = {
  loading: false,
  mail: [],
  error: null,
  alldatanumber: 0,
  is_null: false
};
const mailListReducer = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.FETCH_MAIL_REQUEST:
      return { ...state, loading: true };
    case ActionTypes.FETCH_MAIL_SUCCESS:
      return { ...state, loading: false, mail: action.payload.data_list, alldatanumber: action.payload.all_data_count, is_null: action.payload.data_list.length === 0};
    case ActionTypes.FETCH_MAIL_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default mailListReducer;
